import { convertToCommaString } from "../helpers/Converter"
import "../styles/AmountCard.css"
export const AmountCard = ({title, amount}) => {
    return (
        <div className="amount-card-container">
            <p className="title">{title}</p>
            <p className="amount">{`₹${convertToCommaString(Math.floor(amount))}`}</p>
        </div>
    )
}